if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// const initTermsButton = function () {
//   console.log('adding secondary payment button')
//   const paymentBtn = document.querySelector('[data-shopify="payment-button"] [role="button"]');
//   const moreBtm = document.querySelector('.shopify-payment-button__more-options');
//
//   const termsTpl = `<div class='modal'>
//               <h1>
//                 Terms and Conditions
//                 <span class='t-c-close'>
//                   <svg viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill-rule="evenodd"></path></svg>
//                 </span>
//               </h1>
//               <div class='t-c-checkbox'>
//                 <label class='t-c-checkmark' for="{id}">
//                   <input type="checkbox" id="{id}" name='accepts_terms'>
//                   <span class="checkmark"></span>
//                   <p>I have read and agreed with the <a href="https://store.jigsaw.co/blogs/important-information/photo-release" target="_blank" class="rale-link">photo release</a> and <a href="https://store.jigsaw.co/blogs/important-information/activity-waiver" target="_blank" class="rale-link">activity waiver</a>.</p>
//                 </label>
//                 <p>Please agree to the terms and conditions before making a purchase!</p>
//               </div>
//           </div>`;
//   function activateAcceptTermsModal (e) {
//     setTimeout(() => {
//       if (document.querySelector('.terms-modal')) return;
//       console.log('running')
//       e.preventDefault();
//       e.stopPropagation();
//       const modal = document.createElement('div');
//       modal.classList.add('terms-modal');
//       modal.innerHTML = termsTpl.replace(/{id}/g, 'accepts_terms');
//       document.body.appendChild(modal);
//     },20)
//   }
//
//   function activateAcceptTermsModalForMoreOptions (e) {
//     setTimeout(() => {
//       if (document.querySelector('.terms-modal')) return;
//       console.log('running')
//       e.preventDefault();
//       e.stopPropagation();
//       const modal = document.createElement('div');
//       modal.classList.add('terms-modal');
//       modal.innerHTML = termsTpl.replace(/{id}/g, 'terms-modal-more');
//       document.body.appendChild(modal);
//     },20)
//   }
//
//   document.body.addEventListener('click', function (e) {
//     if (e.target.classList.contains('t-c-close') || e.target.closest('.t-c-close')) {
//       document.querySelectorAll('.terms-modal')
//         .forEach(function (el) {
//           el.outerHTML = null;
//         });
//     }
//   })
//
//   document.body.addEventListener('change', function (e) {
//     if (e.target.id === 'accepts_terms') {
//       paymentBtn.click();
//     }
//   });
//   document.body.addEventListener('change', function (e) {
//     if (e.target.id === 'terms-modal-more') {
//       moreBtm.click();
//     }
//   });
//
//   const newBtn = paymentBtn.cloneNode(true);
//   newBtn.classList.add('duplicated-button');
//   paymentBtn.insertAdjacentElement('beforebegin', newBtn);
//
//   const moreBtnDupe = moreBtm.cloneNode(true);
//   moreBtnDupe.classList.add('duplicated-button');
//   moreBtm.insertAdjacentElement('beforebegin', moreBtnDupe);
//
//   newBtn.addEventListener('click', activateAcceptTermsModal);
//   moreBtnDupe.addEventListener('click', activateAcceptTermsModalForMoreOptions);
//
//   document.querySelector('.product-form__buttons [data-shopify="payment-button"]').classList.add('initialised')
// }
// window.initTermsButton = initTermsButton;



// // Select the node that will be observed for mutations
// const targetNode = document.querySelector(".product__info-container");
//
// // Options for the observer (which mutations to observe)
// const config = { attributes: true, childList: true, subtree: true };
//
// // Callback function to execute when mutations are observed
// const callback = (mutationList, observer) => {
//   for (const mutation of mutationList) {
//     if (mutation.type === "childList") {
//       const elemToWaitFor = document.querySelector('.product-form__buttons [data-shopify="payment-button"] button.shopify-payment-button__button');
//       const addedElem = document.querySelector('.product-form__buttons .duplicated-button');
//       if (elemToWaitFor && !addedElem) {
//         console.log("A child node has been added or removed.");
//         if (window.Shopify && Shopify.PaymentButton) {
//           initTermsButton();
//         }
//       }
//       // else if (!elemToWaitFor && addedElem) {
//       //   document.querySelectorAll('.product-form__buttons .duplicated-button')
//       //     .forEach(function (el) {
//       //       el.outerHTML = null;
//       //     });
//       //   document.querySelector('.product-form__buttons [data-shopify="payment-button"]').classList.remove('initialised')
//       // }
//     }
//   }
// };

// let firstTimeUrl = document.URL;
// document.addEventListener('change', function() {
//   let currentPageUrl = document.URL;
//   let url = new URL(currentPageUrl);
//   let isVariantUrl = url.searchParams.get("variant");
//   currentPageUrl = isVariantUrl ? currentPageUrl : isVariantUrl;
//   if (currentPageUrl && firstTimeUrl !== currentPageUrl) {
//     firstTimeUrl = currentPageUrl;
//     console.log('Grow Url Variant change variant_id: ' + isVariantUrl + '');
//     if (window.Shopify && Shopify.PaymentButton) {
//       document.querySelectorAll('.product-form__buttons .duplicated-button')
//         .forEach(function (el) {
//           el.outerHTML = null;
//         });
//       document.querySelectorAll('.terms-modal')
//         .forEach(function (el) {
//           el.outerHTML = null;
//         });
//       document.querySelector('.product-form__buttons [data-shopify="payment-button"]').classList.remove('initialised')
//       setTimeout(() => {
//         initTermsButton();
//       },1000)
//     }
//   }
// });
//
// // Create an observer instance linked to the callback function
// const observer = new MutationObserver(callback);
//
// // Start observing the target node for configured mutations
// observer.observe(targetNode, config);



// variant option modals..

document.body.addEventListener('click', function (e) {
  if (e.target.closest('.modal-trigger')) {
    e.preventDefault();

    var modal = e.target.closest('.modal-trigger').dataset.triggers;
    document.getElementById(modal).classList.add('open');
  }

  if (e.target.closest('.modal-close')) {
    e.preventDefault();
    var modal = e.target.closest('.product-option-popup');
    if (modal && modal.classList.contains('open'))
      modal.classList.remove('open');
  }

  if (e.target.closest('.product-option-popup')) {
    e.preventDefault();
    if (e.target.classList.contains('product-option-popup') && e.target.classList.contains('open'))
      e.target.classList.remove('open');
  }
});